import { render, staticRenderFns } from "./tabComp4.vue?vue&type=template&id=0cb64d9d&scoped=true&"
import script from "./tabComp4.vue?vue&type=script&lang=js&"
export * from "./tabComp4.vue?vue&type=script&lang=js&"
import style0 from "./tabComp4.vue?vue&type=style&index=0&id=0cb64d9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb64d9d",
  null
  
)

export default component.exports